export enum HttpHeader {
  ContentType = 'content-type',
  Authorization = 'authorization',
  Accept = 'accept',
  ContentDisposition = 'content-disposition'
}
